import { CORS } from 'root/utils/cors/cors';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import { SerializeForm } from 'root/utils/serialize/serializeForm';
import { isMobile } from 'root/utils/isMobile';
import { getParamValueFromUrl } from 'root/utils/URLParams/URLParams';

(function (SerializeForm) {
    const pageLogin = document.querySelector('[data-restaurant-login=container]');

    if (pageLogin) {
        let formData;
        let boxContent = pageLogin.querySelector('[data-restaurant-login=box-content]');
        let contentLoginError = boxContent.querySelector(
            '[data-restaurant-login=content-login-error]'
        );
        let contentLoginErrorMessage = contentLoginError.querySelector(
            '[data-restaurant-login=content-login-error-message]'
        );
        let contentForgottenEmail = boxContent.querySelector(
            '[data-restaurant-login=content-forgotten-email]'
        );
        let contentForgottenEmailSent = boxContent.querySelector(
            '[data-restaurant-login=content-forgotten-email-sent]'
        );
        let boxForms = pageLogin.querySelector('[data-restaurant-login=box-forms]');
        let formLogin = boxForms.querySelector('[data-restaurant-login=forms-login]');
        let formForgotten = boxForms.querySelector(
            '[data-restaurant-login=forms-forgotten]'
        );
        let footerLostPassword = pageLogin.querySelector(
            '[data-restaurant-login=footer-lost-password]'
        );
        let footerBackToLogin = pageLogin.querySelector(
            '[data-restaurant-login=footer-back-to-login]'
        );
        let inputs = pageLogin.querySelectorAll('.gb-form__field-text');
        const loggingHandlerDetailsObj = {
            tags: ['forms', 'login', 'restaurant'],
            fileName: 'restaurant.js',
        };
        const urls = {
            // (http://euw2.posios.com/PosServer/JSON-RPC)
            registrationUrl: 'https://euw2.posios.com/PosServer/RegistrationServlet',
            managementUrl: 'https://euw2.posios.com/management/index.html',
        };

        let init = () => {
            eventBinder();
            showForgotPasswordFormBasedOnUrlParam();
            inputs.forEach(input => {
                if (input.value) raiseLabel(input);
                input.addEventListener('focus', raiseLabel, false);
            });
        };

        const showForgotPasswordFormBasedOnUrlParam = () => {
            return (
                getParamValueFromUrl('forgot-password') &&
                displayFormBasedOnLostPass(false)
            );
        };

        let eventBinder = () => {
            formLogin.addEventListener('submit', eventHandler);
            footerLostPassword.addEventListener(
                'click',
                displayFormBasedOnLostPass.bind(this, false)
            );
            footerBackToLogin.addEventListener(
                'click',
                displayFormBasedOnLostPass.bind(this, true)
            );
            formForgotten.addEventListener('submit', sendTheEmailForReset);
        };

        const raiseLabel = e => {
            const input = e.currentTarget || e;
            const label = input.parentElement.querySelector('.gb-form__field-label');
            label.classList.add('js-raised');
        };

        let eventHandler = e => {
            e.preventDefault();
            controlVisibility(contentLoginError, false);
            formData = {
                username: encodeURIComponent(
                    formLogin.querySelector('[data-restaurant-login=input-email]').value
                ),
                password: encodeURIComponent(
                    formLogin.querySelector('[data-restaurant-login=input-password]')
                        .value
                ),
            };
            login(formData, urls.registrationUrl, urls.managementUrl);
            return false;
        };

        let displayFormBasedOnLostPass = showForm => {
            controlVisibility(formLogin, showForm);
            controlVisibility(formForgotten, !showForm);
            controlVisibility(contentLoginError, false);
            controlVisibility(contentForgottenEmail, !showForm);
            controlVisibility(contentForgottenEmailSent, false);
            controlVisibility(footerLostPassword, showForm);
            controlVisibility(footerBackToLogin, !showForm);
        };

        let sendTheEmailForReset = e => {
            let url = '/rest/resto/Resto-forgot-password';
            if (!validateForm(formForgotten)) {
                return false;
            }
            CORS.xdr(
                url,
                'POST',
                SerializeForm().form(formForgotten),
                formResetCallback,
                formResetCallback
            );

            if (e.preventDefault) {
                e.preventDefault();
            } else {
                e.returnValue = false;
            }
        };

        let controlVisibility = (el, bool = false) => {
            el.style.opacity = bool ? 1 : 0;
            el.style.transition = 'opacity 0.5s';
            setTimeout(() => {
                el.style.display = bool ? 'block' : 'none';
            }, 500);
        };

        let login = (formData, url, murl) => {
            if (!validateForm(formLogin)) {
                return false;
            }
            loggingHandlerDetailsObj.searchTerm = 'resto-login-initiated';
            LoggingHandler().logUserAction(
                'User loaded the restaurant login page',
                loggingHandlerDetailsObj
            );
            sendData(formData, url, murl);
        };

        let validateForm = formEl => {
            if (typeof formEl === 'object' && formEl.nodeName.toLowerCase() === 'form') {
                return Array.from(getFormFields(formEl)).every(field =>
                    field.checkValidity()
                );
            }
        };

        let formResetCallback = () => {
            controlVisibility(formForgotten, false);
            controlVisibility(contentForgottenEmail, false);
            controlVisibility(contentForgottenEmailSent, true);
        };

        let sendData = (formData, url, murl) => {
            let XHR = new XMLHttpRequest();
            XHR.open('POST', url);
            XHR.setRequestHeader(
                'Content-Type',
                'application/x-www-form-urlencoded; charset=UTF-8'
            );
            XHR.withCredentials = false;
            // on success
            XHR.addEventListener('load', XHRLoadCallBack.bind(this, XHR, murl));
            // on error
            XHR.addEventListener('error', XHRErrorCallBack);
            // send data
            XHR.send(
                `method=login&username=${formData.username}&password=${formData.password}`
            );
        };

        let getFormFields = formEl => formEl.querySelectorAll('input,select,textarea');

        let XHRLoadCallBack = (XHR, murl) => {
            let data = JSON.parse(XHR.responseText.replace(/'/g, '"'));
            // in case of user error
            if (data != null && data.error != null) {
                let msg = String(data.error); //the error message coming from data.error is: "Invalid user credentials"
                controlVisibility(contentLoginError, true);
                contentLoginErrorMessage.innerText = msg;

                loggingHandlerDetailsObj.searchTerm = 'resto-login-xhr-load-errors';
                LoggingHandler().logError(msg, loggingHandlerDetailsObj);
            } else if (XHR.status >= 200 && XHR.status < 400) {
                if (data.server !== null && data.server !== undefined) {
                    let protocol = 'https';
                    loggingHandlerDetailsObj.searchTerm = 'resto-login-found-server';
                    LoggingHandler().logUserAction(
                        'Login page found resto-login server',
                        loggingHandlerDetailsObj
                    );
                    login(
                        formData,
                        `${protocol}://${data.server}/PosServer/RegistrationServlet`,
                        `${protocol}://${data.server}/management/index.html`
                    );
                } else {
                    let pnm = '';
                    let pass_for_ipad_login = '';
                    if (window.location.href.indexOf('restaurant/app-signup') > -1) {
                        pass_for_ipad_login = `&password=${formData.password}`;
                    }
                    if (urls.managementUrl !== murl) {
                        let array = murl.split('/')[2].split(':');
                        pnm = `&pnm=switchServer&port=443&server=${array[0]}&extension=/PosServer/JSON-RPC`;
                    }
                    //redirect
                    loggingHandlerDetailsObj.searchTerm = 'resto-login-redirecting-user';
                    LoggingHandler().logUserAction(
                        'Login page is redirecting the user',
                        loggingHandlerDetailsObj
                    );
                    let red = `${murl}?token=${data.token + pass_for_ipad_login}&`;
                    let isMobileOrTablet = isMobile.inMobileDeviceList();
                    let version = isMobileOrTablet ? 'version=1.0' : '';
                    window.location = `${red}${version}&redirect=site${pnm}`;
                }
            }
        };

        let XHRErrorCallBack = function (e) {
            e.preventDefault();
            loggingHandlerDetailsObj.searchTerm = 'resto-login-xhr-errors';
            loggingHandlerDetailsObj.additionalData.error_email = `email:${formData.username}`;
            LoggingHandler().logError(this.statusText, loggingHandlerDetailsObj);
            controlVisibility(contentLoginError, true);
        };

        return {
            init,
        };
    }
})(SerializeForm).init();
